import styled from "styled-components";

export const InfoIcon = styled.span`
  cursor: pointer;
  background-color: lightgray;
  border-radius: 50%;
  padding: 2px 8px !important;
  margin: 0px 5px;
  width: 1rem;
  font-size: 0.8rem;
  box-sizing: border-box;
`;

export const Tooltip = styled.div`
  position: absolute;
  font-family: Poppins;
  font-size: 12px;
  background-color: white;
  border: 1px solid lightgray;
  border-radius: 7px;
  padding: 10px;
  width: 200px;
  z-index: 2;
  @media screen and (max-width: 479px) {
    left: 7%;
    bottom: 10%;
  }
`;
